// wxPay/WxPayRefundOrderBakEdit.tsx
import WxPayRefundOrderEditBase from './WxPayRefundOrderEditBase';

const WxPayRefundOrderBakEdit = (props: any) => (
    <WxPayRefundOrderEditBase apiId="wxPayRefundOrderBak" outerProps={props} />
);

export default WxPayRefundOrderBakEdit;